import { apolloClient } from "../boot/apollo";
import ADD_USER_VISIT from "../graphql/user/addUserVisit.gql";
import END_USER_VISIT from "../graphql/user/endUserVisit.gql";
import UPDATE_USER_VISIT_SECTOR from "../graphql/user/updateUserVisitSector.gql";
import GET_USER_BY_PHONE from "../graphql/user/getUserByPhone.gql";
import REGISTER_USER from "../graphql/user/registerUser.gql";
import VERIFY_USER from "../graphql/user/verifyUser.gql";
import LIST_LATEST_USER_VISITS from "../graphql/user/listLatestUserVisits.gql";
import GET_NUMBER_LATEST_USER_VISITS_BY_SECTOR from "../graphql/user/getNumberLatestUserVisitsBySector.gql";
import RE_SEND_QR_CODE from "../graphql/user/reSendQRCode.gql";

const addUserVisit = (phone, sector) =>
  apolloClient
    .mutate({
      mutation: ADD_USER_VISIT,
      variables: {
        input: { phone, sector }
      }
    })
    .then(({ data }) => data);

const endUserVisit = (phone) =>
  apolloClient
    .mutate({
      mutation: END_USER_VISIT,
      variables: {
        input: { phone }
      }
    })
    .then(({ data }) => data);

const updateUserVisitSector = input =>
  apolloClient
    .mutate({
      mutation: UPDATE_USER_VISIT_SECTOR,
      variables: {
        input
      }
    })
    .then(({ data:{userVisit} }) => userVisit);

const registerUser = usersInput =>
  apolloClient
    .mutate({
      mutation: REGISTER_USER,
      variables: {
        input: usersInput
      }
    })
    .then(({ data }) => data);

const verifyUser = token =>
  apolloClient
    .mutate({
      mutation: VERIFY_USER,
      variables: {
        input: {token}
      }
    })
    .then(({ data }) => data);

const listLatestUserVisits = ({ pagination, search }) =>
  apolloClient
    .query({
      query: LIST_LATEST_USER_VISITS,
      fetchPolicy: "no-cache",
      variables: {
        input: {
          pagination,
          search
        }
      }
    })
    .then(({ data: { userVisits } }) => userVisits);

const getNumberLatestUserVisitsBySector = () =>
  apolloClient
    .query({
      query: GET_NUMBER_LATEST_USER_VISITS_BY_SECTOR,
      fetchPolicy: "no-cache",
      variables: {
      }
    })
    .then(({ data: { userVisitsPerSector } }) => userVisitsPerSector);

const reSendQRCode = (phone) =>
  apolloClient
    .mutate({
      mutation: RE_SEND_QR_CODE,
      variables: {
        input: { phone }
      }
    })
    .then(({ data }) => data);


const getUserByPhone = (phone) =>
  apolloClient
  .query({
    query: GET_USER_BY_PHONE,
    variables: {
     phone
    },
    fetchPolicy:"no-cache"
  })
  .then(({ data:user }) => user);

export {
  addUserVisit,
  updateUserVisitSector,
  registerUser,
  verifyUser,
  listLatestUserVisits,
  getNumberLatestUserVisitsBySector,
  reSendQRCode,
  getUserByPhone,
  endUserVisit
};
